export function UpdatingPill() {
  return (
    <span
      role="status"
      className="inline-flex items-center gap-1.5 rounded-full border border-border bg-surface-elevated px-2 py-0.5"
    >
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-cyan" aria-hidden />
      <span className="text-xs font-medium uppercase tracking-wide text-muted">Updating</span>
    </span>
  );
}